// bill_subsystem_v1 + bill_send_to_customer_v1: send invoice to customer modal
import React, { useState, useEffect } from 'react';
import API from '../api';

export default function BillInvoiceSendModal(props) {
  const invoice = props.invoice;
  const onClose = props.onClose;
  const [customers, setCustomers] = useState([]);
  const [customerId, setCustomerId] = useState(invoice && invoice.tenant_customer_id ? invoice.tenant_customer_id : '');
  const [channel, setChannel] = useState('telegram');
  const [customMessage, setCustomMessage] = useState('');
  const [sending, setSending] = useState(false);
  const [error, setError] = useState('');
  /* backdrop_close_fix_v1: ปิดเฉพาะเมื่อกด+ปล่อยบน backdrop จริงๆ */
  const overlayMouseDown = React.useRef(false);
  const [result, setResult] = useState(null);

  useEffect(function () {
    API.get('/api/customers').then(function (r) { setCustomers(r.data || []); }).catch(function () {});
  }, []);

  var selectedCustomer = customers.find(function (c) { return c.id === customerId; });
  var hasTelegram = selectedCustomer && selectedCustomer.telegram_chat_id;
  var hasLine = selectedCustomer && selectedCustomer.line_user_id;
  var canSendChosen = (channel === 'telegram' && hasTelegram) || (channel === 'line' && hasLine);

  async function handleSend() {
    setError('');
    setResult(null);
    if (!customerId) { setError('กรุณาเลือกลูกค้า'); return; }
    if (!canSendChosen) { setError('ลูกค้านี้ไม่มี ' + (channel === 'telegram' ? 'Telegram Chat ID' : 'LINE User ID')); return; }

    setSending(true);
    try {
      var res = await API.post('/api/invoices/' + invoice.id + '/send-to-customer', {
        customer_id: customerId,
        channel: channel,
        custom_message: customMessage.trim() || null,
      });
      setResult(res.data);
      setTimeout(function () { onClose(true); }, 1500);
    } catch (err) {
      var errData = err.response && err.response.data;
      var msg = (errData && errData.error) || 'ส่งไม่สำเร็จ';
      if (errData && errData.detail) msg += ' (' + errData.detail + ')';
      setError(msg);
    } finally {
      setSending(false);
    }
  }

  return (
    <div
      onMouseDown={function (e) { overlayMouseDown.current = (e.target === e.currentTarget); }}
      onClick={function (e) { if (!sending && e.target === e.currentTarget && overlayMouseDown.current) onClose(false); }}
      style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, zIndex: 100 }}>
      <div onClick={function (e) { e.stopPropagation(); }} style={{ background: 'white', borderRadius: 14, padding: 24, maxWidth: 480, width: '100%' }}>
        <h3 style={{ margin: '0 0 4px' }}>📤 ส่งใบแจ้งหนี้ {invoice && invoice.invoice_number}</h3>
        <p style={{ margin: '0 0 16px', fontSize: 13, color: '#64748b' }}>ส่งให้ลูกค้าผ่าน Telegram หรือ LINE</p>

        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 13, color: '#475569' }}>เลือกลูกค้า <span style={{ color: '#dc2626' }}>*</span></label>
          <select value={customerId} onChange={function (e) { setCustomerId(e.target.value); }} disabled={sending} style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, fontFamily: 'inherit' }}>
            <option value="">— เลือก —</option>
            {customers.map(function (c) {
              var marks = [];
              if (c.telegram_chat_id) marks.push('📱');
              if (c.line_user_id) marks.push('💬');
              return <option key={c.id} value={c.id}>{c.name} {marks.length > 0 ? '(' + marks.join('') + ')' : '(ไม่มีช่อง)'}</option>;
            })}
          </select>
        </div>

        <div style={{ marginBottom: 12 }}>
          <label style={{ fontSize: 13, color: '#475569' }}>ช่องทาง</label>
          <div style={{ display: 'flex', gap: 8, marginTop: 6 }}>
            <button onClick={function () { setChannel('telegram'); }} disabled={!hasTelegram} style={{ flex: 1, padding: '10px 12px', borderRadius: 8, border: channel === 'telegram' ? '2px solid #10b981' : '1px solid #e2e8f0', background: channel === 'telegram' ? '#ecfdf5' : 'white', cursor: hasTelegram ? 'pointer' : 'not-allowed', opacity: hasTelegram ? 1 : 0.4, fontSize: 14, fontWeight: channel === 'telegram' ? 600 : 400 }}>📱 Telegram {!hasTelegram && customerId ? '(ไม่มี ID)' : ''}</button>
            <button onClick={function () { setChannel('line'); }} disabled={!hasLine} style={{ flex: 1, padding: '10px 12px', borderRadius: 8, border: channel === 'line' ? '2px solid #10b981' : '1px solid #e2e8f0', background: channel === 'line' ? '#ecfdf5' : 'white', cursor: hasLine ? 'pointer' : 'not-allowed', opacity: hasLine ? 1 : 0.4, fontSize: 14, fontWeight: channel === 'line' ? 600 : 400 }}>💬 LINE {!hasLine && customerId ? '(ไม่มี ID)' : ''}</button>
          </div>
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ fontSize: 13, color: '#475569' }}>ข้อความเพิ่มเติม (optional)</label>
          <textarea value={customMessage} onChange={function (e) { setCustomMessage(e.target.value); }} rows={3} disabled={sending} placeholder="เช่น สวัสดีค่ะ ฝากชำระภายในวันที่ ... ขอบคุณค่ะ" style={{ width: '100%', padding: 10, borderRadius: 8, border: '1px solid #e2e8f0', fontSize: 14, marginTop: 4, boxSizing: 'border-box', fontFamily: 'inherit', resize: 'vertical' }} />
        </div>

        {error && <div style={{ background: '#fef2f2', color: '#dc2626', padding: 10, borderRadius: 8, fontSize: 13, marginBottom: 12 }}>⚠️ {error}</div>}
        {result && <div style={{ background: '#dcfce7', color: '#15803d', padding: 10, borderRadius: 8, fontSize: 13, marginBottom: 12, fontWeight: 600 }}>✅ ส่งสำเร็จ!</div>}

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={function () { onClose(false); }} disabled={sending} style={{ padding: '8px 16px', borderRadius: 8, border: '1px solid #e2e8f0', background: 'white', cursor: 'pointer', fontSize: 14 }}>ยกเลิก</button>
          <button onClick={handleSend} disabled={sending || !canSendChosen} style={{ padding: '8px 16px', borderRadius: 8, border: 'none', background: (sending || !canSendChosen) ? '#94a3b8' : '#10b981', color: 'white', cursor: (sending || !canSendChosen) ? 'not-allowed' : 'pointer', fontSize: 14, fontWeight: 600 }}>{sending ? 'กำลังส่ง...' : '📤 ส่ง'}</button>
        </div>
      </div>
    </div>
  );
}
